import { Bio } from "../../components/ResumeComponents/Bio";
import { Education } from "../../components/ResumeComponents/Education";
import { Experience } from "../../components/ResumeComponents/Experience";
import { Info } from "../../components/ResumeComponents/Info";
import Layout from "../../components/layout";
import { Projects } from "../../components/ResumeComponents/Projects";
import { Skills } from "../../components/ResumeComponents/Skills";

export default ({ data }) => {
  return (
    <Layout disableExtra>
      {/* Sticky Header */}
      <div className="fixed top-4 left-4 z-50">
        <a
          href="/"
          className="bg-transparent text-white px-4 py-2 rounded border border-transparent hover:border-white transition-colors duration-200"
        >
          ← Back to Home
        </a>
      </div>

      {/* Main Content */}
      <div
        className="max-w-screen-lg m-auto min-h-screen pt-20 pb-20 overflow-auto h-screen hide-scrollbar"
      >
        <div className="grid grid-cols-2 gap-4">
          <div>
            {/* <img className="w-9/12 ml-20 border border-transparent rounded" src="/cvimage.jpg" /> */}
            <Info data={data.info} />
            <Bio data={data.bio} />
            <Skills data={data.skills} />
          </div>
          <div>
            <h1 className="text-3xl mb-20">{data.title}</h1>
            <Education data={data.education} />
            <Experience data={data.experience} />
          </div>
        </div>
        <Projects data={data.projects} />
      </div>
    </Layout>
  );
};
